/**
 * Which roles a share menu offers next to a note's link (share-sheet plan,
 * "Roles follow the link"): nobody invited has less than the link gives, so
 * with an edit link only "editor" is left. The worker refuses a role below the
 * link with the same rule. Mirrored in Swift (CaliuCore) and Kotlin (:core),
 * all running `shareRoles.fixtures.json`. Change all three or none.
 */

export type ShareLinkAccess = "none" | "view" | "edit"
export type ShareRole = "editor" | "viewer"

const ALL_ROLES: readonly ShareRole[] = ["viewer", "editor"]
const EDITOR_ONLY: readonly ShareRole[] = ["editor"]

/** Roles a new invite may get with this link. */
export function inviteRoles(link: ShareLinkAccess): ShareRole[] {
  return [...(link === "edit" ? EDITOR_ONLY : ALL_ROLES)]
}

/** Roles an existing member (or pending invite) may be set to with this link. */
export function memberRoles(link: ShareLinkAccess): ShareRole[] {
  return [...(link === "edit" ? EDITOR_ONLY : ALL_ROLES)]
}
